"use client"
import { useState, useEffect } from "react"
import { ChevronDown, MessageCircle, X } from "lucide-react"
import {Link} from 'react-router-dom'

export default function TrainingCentersPage() {
  const [isScrolled, setIsScrolled] = useState(false)
  const [isChatOpen, setIsChatOpen] = useState(false)
  const [isMoreDropdownOpen, setIsMoreDropdownOpen] = useState(false)

  const footerLinks = [
    { to: "/", label: "HOME" },
    { to: "/psdct", label: "PSDCT LIVE MODE" },
    { to: "/terms", label: "TERM & CONDITIONS" },
    { to: "/quick-payment", label: "QUICK PAY ANY FEES" },
    { to: "/registration-policy", label: "REGISTRATION POLICY" },
    { to: "/cancellation", label: "CANCELLATION POLICY" },
    { to: "/careers", label: "CAREERS" },
    { to: "/contact", label: "CONTACT US" },
    { to: "/franchise", label: "FRANCHISE" },
    { to: "/free", label: "FREE" },
    { to: "/students", label: "STUDENTS" },
    { to: "/training", label: "TRAINING CENTERS" },
  ]

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const handleChatSubmit = (e) => {
    e.preventDefault()
    console.log("Chat form submitted")
  }

  return (
    <div className="bg-white text-gray-800 min-h-screen overflow-x-hidden">
      {/* Header */}
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          isScrolled
            ? "bg-white/20 backdrop-blur-2xl border-b border-white/10 shadow-xl"
            : "bg-gray-900/30 backdrop-blur-xl text-white border-b border-white/5"
        }`}
      >
        <div className="container mx-auto flex justify-between items-center p-4">
          <div
            className={`text-2xl font-bold transition-all duration-500 ${isScrolled ? "text-[#06b6d4]" : "text-white"}`}
          >
            <Link to="/" className="relative inline-block">
              <span className="bg-gradient-to-r from-[#00d4ff] via-[#5b21b6] to-[#ec4899] bg-clip-text text-transparent">
                StructuralGuru
              </span>
              <div className="absolute -inset-3 bg-gradient-to-r from-[#00d4ff]/20 via-[#5b21b6]/20 to-[#ec4899]/20 rounded-2xl blur-2xl opacity-50 animate-pulse"></div>
              <div
                className="absolute -inset-4 bg-gradient-to-r from-[#00d4ff]/15 via-[#5b21b6]/15 to-[#ec4899]/15 rounded-3xl blur-3xl opacity-30 animate-pulse"
                style={{ animationDelay: "1s" }}
              ></div>
            </Link>
          </div>
          <nav className="hidden md:flex space-x-6">
            <Link
              to="/"
              className={`relative font-medium transition-all duration-300 hover:scale-105 ${
                isScrolled ? "text-gray-700 hover:text-[#0f766e]" : "text-white hover:text-gray-200"
              } ${
                isScrolled
                  ? "hover:shadow-[0_0_15px_rgba(6,182,212,0.5)] hover:border hover:border-[#06b6d4]/50"
                  : "hover:shadow-[0_0_15px_rgba(255,255,255,0.4)] hover:border hover:border-white/50"
              } rounded-lg px-2 py-1 overflow-hidden after:content-[''] after:absolute after:w-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-current after:transition-all after:duration-300 hover:after:w-full`}
            >
              HOME
            </Link>
            <Link
              to="/about"
              className={`relative font-medium transition-all duration-300 hover:scale-105 ${
                isScrolled ? "text-gray-700 hover:text-[#0f766e]" : "text-white hover:text-gray-200"
              } ${
                isScrolled
                  ? "hover:shadow-[0_0_15px_rgba(6,182,212,0.5)] hover:border hover:border-[#06b6d4]/50"
                  : "hover:shadow-[0_0_15px_rgba(255,255,255,0.4)] hover:border hover:border-white/50"
              } rounded-lg px-2 py-1 overflow-hidden after:content-[''] after:absolute after:w-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-current after:transition-all after:duration-300 hover:after:w-full`}
            >
              ABOUT US
            </Link>
            <Link
              to="/services"
              className={`relative font-medium transition-all duration-300 hover:scale-105 ${
                isScrolled ? "text-gray-700 hover:text-[#0f766e]" : "text-white hover:text-gray-200"
              } ${
                isScrolled
                  ? "hover:shadow-[0_0_15px_rgba(6,182,212,0.5)] hover:border hover:border-[#06b6d4]/50"
                  : "hover:shadow-[0_0_15px_rgba(255,255,255,0.4)] hover:border hover:border-white/50"
              } rounded-lg px-2 py-1 overflow-hidden after:content-[''] after:absolute after:w-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-current after:transition-all after:duration-300 hover:after:w-full`}
            >
              SERVICES
            </Link>
            <Link
              to="/projects"
              className={`relative font-medium transition-all duration-300 hover:scale-105 ${
                isScrolled ? "text-gray-700 hover:text-[#0f766e]" : "text-white hover:text-gray-200"
              } ${
                isScrolled
                  ? "hover:shadow-[0_0_15px_rgba(6,182,212,0.5)] hover:border hover:border-[#06b6d4]/50"
                  : "hover:shadow-[0_0_15px_rgba(255,255,255,0.4)] hover:border hover:border-white/50"
              } rounded-lg px-2 py-1 overflow-hidden after:content-[''] after:absolute after:w-0 after:h-0.5 after:bottom-0 after:left-0 after:bg-current after:transition-all after:duration-300 hover:after:w-full`}
            >
              OUR ENGG PROJECTS
            </Link>
            <div className="relative">
              <button
                onClick={() => setIsMoreDropdownOpen(!isMoreDropdownOpen)}
                className={`flex items-center space-x-1 font-medium transition-all duration-300 hover:scale-105 ${
                  isScrolled ? "text-gray-700 hover:text-[#0f766e]" : "text-white hover:text-gray-200"
                } ${
                  isScrolled
                    ? "hover:shadow-[0_0_15px_rgba(6,182,212,0.5)] hover:border hover:border-[#06b6d4]/50"
                    : "hover:shadow-[0_0_15px_rgba(255,255,255,0.4)] hover:border hover:border-white/50"
                } rounded-lg px-2 py-1`}
                aria-expanded={isMoreDropdownOpen}
                aria-haspopup="true"
              >
                <span>MORE</span>
                <ChevronDown
                  className={`w-4 h-4 transition-transform duration-300 ${isMoreDropdownOpen ? "rotate-180" : ""}`}
                />
              </button>
              <div
                className={`absolute top-full right-0 mt-2 w-48 bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-gray-200/20 overflow-hidden transition-all duration-300 ${
                  isMoreDropdownOpen ? "opacity-100 translate-y-0 visible" : "opacity-0 -translate-y-4 invisible"
                }`}
              >
                <Link
                  to="/privacy"
                  className="block px-6 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#0f766e] transition-all duration-200"
                  onClick={() => setIsMoreDropdownOpen(false)}
                >
                  Privacy Policy
                </Link>
                <Link
                  to="/quality"
                  className="block px-6 py-3 text-gray-700 hover:bg-gray-50 hover:text-[#0f766e] transition-all duration-200"
                  onClick={() => setIsMoreDropdownOpen(false)}
                >
                  Quality Policy
                </Link>
              </div>
            </div>
          </nav>
          {/* Mobile menu button */}
          <button className="md:hidden text-white">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </header>

      {/* Training Centers Section */}
      <section className="px-6 bg-gray-50 relative overflow-hidden pt-20">
        {/* Animated background elements */}
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-br from-[#0f766e]/10 via-white/95 to-[#7c3aed]/10"></div>
          <div className="absolute top-20 left-10 w-72 h-72 bg-gradient-to-r from-[#06b6d4]/20 to-[#8b5cf6]/10 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-gradient-to-l from-[#7c3aed]/20 to-[#06b6d4]/10 rounded-full blur-3xl animate-pulse"></div>
        </div>

        <div className="max-w-5xl mx-auto bg-white/60 backdrop-blur-xl p-8 my-16 rounded-3xl shadow-2xl border border-white/20 relative">
          <h1 className="text-3xl font-bold mb-6 text-center">
            <span className="bg-gradient-to-r from-[#0f766e] via-[#7c3aed] to-[#0f766e] bg-clip-text text-transparent">
              Training Centers
            </span>
          </h1>
          <p className="text-lg text-center mb-8 text-gray-600 max-w-3xl mx-auto leading-relaxed">
            StructuralGuru offers structural design training across multiple modes and centers, both online and
            in-person.
          </p>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-10">
            {/* Offline Training Centers */}
            <div className="bg-gradient-to-br from-[#0f766e]/10 via-[#06b6d4]/5 to-[#7c3aed]/10 p-6 rounded-2xl border border-white/30 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-[#06b6d4]/5 to-[#7c3aed]/5 blur-xl"></div>
              <div className="relative z-10">
                <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
                  <svg className="w-5 h-5 text-[#06b6d4]" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      fillRule="evenodd"
                      d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span className="bg-gradient-to-r from-[#0f766e] to-[#7c3aed] bg-clip-text text-transparent">
                    Offline Training Centers
                  </span>
                </h2>
                <ul className="space-y-3">
                  <li className="group flex items-start gap-3 p-3 bg-white/30 backdrop-blur-sm rounded-xl hover:bg-white/50 hover:shadow-md transition-all duration-300 hover:scale-105">
                    <div className="w-2 h-2 bg-gradient-to-r from-[#06b6d4] to-[#7c3aed] rounded-full mt-2 flex-shrink-0 group-hover:scale-150 transition-transform duration-300"></div>
                    <div>
                      <strong className="bg-gradient-to-r from-[#0f766e] to-[#7c3aed] bg-clip-text text-transparent">
                        Trichy (Head Office-Virtual Base)
                      </strong>
                      <p className="text-gray-600 text-sm">Primary training center and consultancy hub</p>
                    </div>
                  </li>
                  <li className="group flex items-start gap-3 p-3 bg-white/30 backdrop-blur-sm rounded-xl hover:bg-white/50 hover:shadow-md transition-all duration-300 hover:scale-105">
                    <div className="w-2 h-2 bg-gradient-to-r from-[#06b6d4] to-[#7c3aed] rounded-full mt-2 flex-shrink-0 group-hover:scale-150 transition-transform duration-300"></div>
                    <div>
                      <strong className="bg-gradient-to-r from-[#0f766e] to-[#7c3aed] bg-clip-text text-transparent">
                        Chennai (Offline Mode Only)
                      </strong>
                      <p className="text-gray-600 text-sm">Weekend programs and certification camps</p>
                    </div>
                  </li>
                  <li className="group flex items-start gap-3 p-3 bg-white/30 backdrop-blur-sm rounded-xl hover:bg-white/50 hover:shadow-md transition-all duration-300 hover:scale-105">
                    <div className="w-2 h-2 bg-gradient-to-r from-[#06b6d4] to-[#7c3aed] rounded-full mt-2 flex-shrink-0 group-hover:scale-150 transition-transform duration-300"></div>
                    <div>
                      <strong className="bg-gradient-to-r from-[#0f766e] to-[#7c3aed] bg-clip-text text-transparent">
                        Banglore (Offline Mode only)
                      </strong>
                      <p className="text-gray-600 text-sm">Periodic training batches hosted in collaboration</p>
                    </div>
                  </li>
                  <li className="group flex items-start gap-3 p-3 bg-white/30 backdrop-blur-sm rounded-xl hover:bg-white/50 hover:shadow-md transition-all duration-300 hover:scale-105">
                    <div className="w-2 h-2 bg-gradient-to-r from-[#06b6d4] to-[#7c3aed] rounded-full mt-2 flex-shrink-0 group-hover:scale-150 transition-transform duration-300"></div>
                    <div>
                      <strong className="bg-gradient-to-r from-[#0f766e] to-[#7c3aed] bg-clip-text text-transparent">
                        College Tie-ups
                      </strong>
                      <p className="text-gray-600 text-sm">In-campus training for civil engineering students</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>

            {/* Online Training Modes */}
            <div className="bg-gradient-to-br from-[#7c3aed]/10 via-[#06b6d4]/5 to-[#0f766e]/10 p-6 rounded-2xl border border-white/30 relative overflow-hidden">
              <div className="absolute inset-0 bg-gradient-to-r from-[#7c3aed]/5 to-[#06b6d4]/5 blur-xl"></div>
              <div className="relative z-10">
                <h2 className="text-xl font-semibold mb-4 flex items-center gap-2">
                  <svg className="w-5 h-5 text-[#7c3aed]" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6zM14.553 7.106A1 1 0 0014 8v4a1 1 0 00.553.894l2 1A1 1 0 0018 13V7a1 1 0 00-1.447-.894l-2 1z" />
                  </svg>
                  <span className="bg-gradient-to-r from-[#7c3aed] to-[#0f766e] bg-clip-text text-transparent">
                    Online Training Modes
                  </span>
                </h2>
                <ul className="space-y-3">
                  <li className="group flex items-start gap-3 p-3 bg-white/30 backdrop-blur-sm rounded-xl hover:bg-white/50 hover:shadow-md transition-all duration-300 hover:scale-105">
                    <div className="w-2 h-2 bg-gradient-to-r from-[#7c3aed] to-[#06b6d4] rounded-full mt-2 flex-shrink-0 group-hover:scale-150 transition-transform duration-300"></div>
                    <div>
                      <strong className="bg-gradient-to-r from-[#7c3aed] to-[#0f766e] bg-clip-text text-transparent">
                        Webinar Mode
                      </strong>
                      <p className="text-gray-600 text-sm">Live interactive Zoom/Google Meet sessions</p>
                    </div>
                  </li>
                  <li className="group flex items-start gap-3 p-3 bg-white/30 backdrop-blur-sm rounded-xl hover:bg-white/50 hover:shadow-md transition-all duration-300 hover:scale-105">
                    <div className="w-2 h-2 bg-gradient-to-r from-[#7c3aed] to-[#06b6d4] rounded-full mt-2 flex-shrink-0 group-hover:scale-150 transition-transform duration-300"></div>
                    <div>
                      <strong className="bg-gradient-to-r from-[#7c3aed] to-[#0f766e] bg-clip-text text-transparent">
                        Video Mode
                      </strong>
                      <p className="text-gray-600 text-sm">Pre-recorded structured video courses with materials</p>
                    </div>
                  </li>
                  <li className="group flex items-start gap-3 p-3 bg-white/30 backdrop-blur-sm rounded-xl hover:bg-white/50 hover:shadow-md transition-all duration-300 hover:scale-105">
                    <div className="w-2 h-2 bg-gradient-to-r from-[#7c3aed] to-[#06b6d4] rounded-full mt-2 flex-shrink-0 group-hover:scale-150 transition-transform duration-300"></div>
                    <div>
                      <strong className="bg-gradient-to-r from-[#7c3aed] to-[#0f766e] bg-clip-text text-transparent">
                        Doubt Clearing
                      </strong>
                      <p className="text-gray-600 text-sm">Dedicated sessions and WhatsApp/email support</p>
                    </div>
                  </li>
                  <li className="group flex items-start gap-3 p-3 bg-white/30 backdrop-blur-sm rounded-xl hover:bg-white/50 hover:shadow-md transition-all duration-300 hover:scale-105">
                    <div className="w-2 h-2 bg-gradient-to-r from-[#7c3aed] to-[#06b6d4] rounded-full mt-2 flex-shrink-0 group-hover:scale-150 transition-transform duration-300"></div>
                    <div>
                      <strong className="bg-gradient-to-r from-[#7c3aed] to-[#0f766e] bg-clip-text text-transparent">
                        Assessment & Certification
                      </strong>
                      <p className="text-gray-600 text-sm">Post-course tests with official certificates</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="text-center">
            <button
              asChild
              className="bg-gradient-to-r from-[#0f766e] to-[#7c3aed] hover:from-[#06b6d4] hover:to-[#8b5cf6] text-white px-8 py-3 rounded-full font-semibold transition-all duration-300 hover:shadow-lg hover:scale-105 hover:-translate-y-0.5 hover:shadow-[0_0_15px_rgba(6,182,212,0.5)]"
            >
              <Link to="/register">Join a Training Program</Link>
            </button>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-900 text-white text-sm py-10 relative overflow-hidden">
        <div className="relative z-10">
          <div className="container mx-auto">
            <div className="flex flex-wrap justify-center gap-4 text-center mb-6">
              {footerLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.to}
                  className="px-4 py-2 text-sm text-gray-300 hover:text-white hover:bg-gradient-to-r hover:from-[#06b6d4] hover:to-[#7c3aed] transition-all duration-300 border border-gray-600 rounded-lg hover:border-[#06b6d4] hover:shadow-[0_0_15px_rgba(6,182,212,0.5)] relative overflow-hidden group transform hover:scale-105 hover:-translate-y-1"
                >
                  <span className="relative z-10">{link.label}</span>
                  <div className="absolute inset-0 bg-gradient-to-r from-[#06b6d4]/20 to-[#7c3aed]/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                  <div className="absolute bottom-0 left-0 w-0 h-0.5 bg-[#06b6d4] group-hover:w-full transition-all duration-300"></div>
                </Link>
              ))}
            </div>
            <div className="text-center">
              <p className="text-gray-400 mb-2">
                &copy; 2025 StructuralGuru - GURURAYAR ASSOCIATES. All Rights Reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* Floating Chat Widget */}
      <div className="fixed bottom-6 right-6 z-50">
        <button
          onClick={() => setIsChatOpen(!isChatOpen)}
          className="bg-gradient-to-r from-[#0f766e] to-[#7c3aed] text-white p-4 rounded-full shadow-2xl hover:shadow-[0_0_25px_rgba(6,182,212,0.6)] transition-all duration-300 hover:scale-110 hover:-translate-y-1 relative overflow-hidden group"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-[#06b6d4]/30 to-[#8b5cf6]/30 opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-full"></div>
          {isChatOpen ? <X className="w-6 h-6 relative z-10" /> : <MessageCircle className="w-6 h-6 relative z-10" />}
        </button>
      </div>

      {/* Chat Box */}
      <div
        className={`fixed bottom-24 right-6 w-80 bg-white/95 backdrop-blur-xl border border-gray-200/20 rounded-3xl shadow-2xl transition-all duration-500 z-40 ${
          isChatOpen ? "opacity-100 translate-y-0 visible" : "opacity-0 translate-y-8 invisible"
        }`}
      >
        <div className="p-6">
          <h3 className="text-xl font-semibold text-[#0f766e] mb-6 text-center">Customer Support</h3>
          <form onSubmit={handleChatSubmit} className="space-y-4">
            <div className="relative">
              <input
                type="text"
                placeholder="Your Name"
                className="w-full px-4 py-3 bg-gray-50/50 border border-gray-200/50 rounded-2xl focus:outline-none focus:ring-2 focus:ring-[#0f766e]/20 focus:border-[#0f766e]/30 transition-all duration-300"
                required
              />
            </div>
            <div className="relative">
              <input
                type="email"
                placeholder="Your Email"
                className="w-full px-4 py-3 bg-gray-50/50 border border-gray-200/50 rounded-2xl focus:outline-none focus:ring-2 focus:ring-[#0f766e]/20 focus:border-[#0f766e]/30 transition-all duration-300"
                required
              />
            </div>
            <div className="relative">
              <textarea
                placeholder="How can I help you?"
                rows={3}
                className="w-full px-4 py-3 bg-gray-50/50 border border-gray-200/50 rounded-2xl focus:outline-none focus:ring-2 focus:ring-[#0f766e]/20 focus:border-[#0f766e]/30 transition-all duration-300 resize-none"
                required
              ></textarea>
            </div>
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-[#0f766e] to-[#7c3aed] text-white py-3 rounded-2xl font-medium transition-all duration-300 hover:shadow-lg hover:scale-105 hover:-translate-y-0.5 hover:shadow-[0_0_15px_rgba(6,182,212,0.5)]"
            >
              Customer Care for Support
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}
